(() => {
  if (window.__ottoReportUIError) return;
  const allowed = new Set(['cart_read', 'cart_write', 'search', 'filters', 'load_more', 'stock_signup']);
  window.__ottoReportUIError = (area) => {
    if (!allowed.has(area) || !window.__ottoConsent?.analytics || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'storefront_error',
        area,
        version: 'cro-2026-09-06.1',
        locale: document.documentElement.lang,
        country: document.documentElement.dataset.countryCode || '',
        device: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop',
        currency: document.documentElement.dataset.currencyCode || '',
      });
    } catch (_) {}
  };
})();
